/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
query SenderRoutePlanReadQuery($routePlanId: ID) {
  SenderRoutePlanRead(routePlanId: $routePlanId) {
    id,
    createdAt,
    updatedAt,
    regex,
    message,
    status,
    Mcc {
      mcc,
      countryName,
      Mnc {
        mnc,
        network
      }
    },
    Mnc {
      id,
      mnc,
      network
    },
    SenderRoute {
      displayName
    },
    SenderIdDirectory {
      id,
      displayName
    },
    SenderId {
      id,
      senderId
    },
    SenderIdVendorAccount {
      id,
      displayName
    }
    VendorAccount {
      id,
      displayName
    }
  }
}
`
